<template>
  <a-drawer
    title="阅读记录"
    v-model:open="state.showReadingRecord"
    class="small"
    width="70%"
  >
    <a-alert
      :message="readingRecordState.topMessage"
      type="info"
      class="text-12px"
      show-icon
    />
    <a-tabs size="small" v-model:activeKey="readingRecordState.activeKey">
      <a-tab-pane :key="1" tab="内部员工">
        <remote-table
          ref="tableRef"
          menuName="announcementReadRecordInner"
          showSetting
          interfaceURL="/announcement-center/read-record"
          :y="readingRecordState.scrollY"
          :sy="readingRecordState.scrollY"
          hasExport
          @exportExcel="exportEvent"
          :apiParams="{ scopeType: 1, announcementId: props.id }"
          :showSelection="false"
        >
          <template #isReadStrCR="{record}">
            <a-button
              class="bg-color-[#F6FFED] text-color-[#B7EB8F] border-solid border-color-[#B7EB8F]"
              size="small"
              v-if="record.isReadStr === '已读'"
              >{{ record.isReadStr }}</a-button
            >
            <a-button
              class="bg-color-[#FFF1F0]"
              size="small"
              danger
              v-if="record.isReadStr === '未读'"
              >{{ record.isReadStr }}</a-button
            >
          </template>
        </remote-table>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="外部供应商">
        <remote-table
          ref="tableRef"
          menuName="announcementReadRecordSupplier"
          showSetting
          interfaceURL="/announcement-center/read-record"
          :y="readingRecordState.scrollY"
          :sy="readingRecordState.scrollY"
          hasExport
          @exportExcel="exportEvent"
          :apiParams="{ scopeType: 2, announcementId: props.id }"
          :showSelection="false"
        >
          <template #isReadStrCR="{record}">
            <a-button
              class="bg-color-[#F6FFED] text-color-[#B7EB8F] border-solid border-color-[#B7EB8F]"
              size="small"
              v-if="record.isReadStr === '已读'"
              >{{ record.isReadStr }}</a-button
            >
            <a-button
              class="bg-color-[#FFF1F0]"
              size="small"
              danger
              v-if="record.isReadStr === '未读'"
              >{{ record.isReadStr }}</a-button
            >
          </template>
        </remote-table>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
</template>
<script setup>
import { inject, defineProps } from 'vue'
import { useReadingRecord } from '../share'

const props = defineProps({
  id: {
    type: [String, Number],
    default: null
  }
})
const noticePublishModule = inject('noticePublishModule')
const { state } = noticePublishModule
const { readingRecordState, exportEvent } = useReadingRecord(props)
</script>
<style lang="scss" scoped>
:deep(.portal-ant-list-item-meta-description) {
  font-size: 12px;
}
:deep(.portal-ant-list-item) {
  padding: 6px;
}
</style>
